<template>
    <div>
        <b-modal :id="modalId"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]"
            modal-class="modal-serial"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="serial-modal__close"
                v-if="!isShowFooterClose"
                @click="clickClose"></div>
            <div class="serial-modal__content">
                <!-- Success Banner -->
                <div class="serial-modal__banner serial-modal__banner--success" v-if="tag == 'detail' && campaign.serial != 'XXXXXXX'">
                    <div class="serial-modal__banner-content">
                        <img src="@/assets/icon/ic-success-serial.svg" alt="success" />
                        <span class="serial-modal__banner-text">{{ lbl.serial.redeem_success }}</span>
                    </div>
                </div>
                <!-- Error Banner (Expired) -->
                <div class="serial-modal__banner serial-modal__banner--error" v-if="tag == 'detail' && campaign.serial == 'XXXXXXX'">
                    <div class="serial-modal__banner-content">
                        <img src="@/assets/icon/ic-error-serial.svg" alt="error" />
                        <span class="serial-modal__banner-text">{{ lbl.serial.redeem_expire }}</span>
                    </div>
                </div>
                
                <div class="serial-modal__header">
                    <SerialHeader
                        :campaign="campaign" />
                </div>
                <div class="serial-modal__body">
                    <Serial
                        :lbl="lbl"
                        :campaign="campaign"
                        :campaignGroup="campaignGroup"
                        :controller="controller"
                        :tag="tag"
                        @serialExpired="onSerialExpired"
                        v-if="serialType == 'serial'" />
                    <SerialRefillInfo
                        :lbl="lbl"
                        :controller="controller"
                        :group="this.campaignGroup"
                        @clickRefillInformation="clickRefillInformation"
                        v-if="serialType == 'refillinfo'" />
                    <FormatDate
                        id="redeem_on_date"
                        :lbl="redeemOnLbl"
                        :isUtc="true"
                        :isShowTime="true"
                        :campaign="campaign"
                        v-if="serialType == 'serial'" />
                    <SerialTimer
                        :lbl="lbl"
                        :campaign="campaign"
                        :controller="controller"
                        v-if="isMinMatch || isShowTimer" />
                </div>
                <div class="serial-modal__footer">
                    <div class="serial-modal__footer-separator"></div>
                    <SerialFooter
                        :lbl="lbl.serial"
                        :controller="controller"
                        :isShowFooterClose="isShowFooterClose"
                        :isShowCancelRedemption="isShowCancelRedemption"
                        :campaignGroup="campaignGroup"
                        @clickToMyCoupon="clickToMyCoupon"
                        @clickBackToPrivilege="clickBackToPrivilege"
                        @clickContinueToProceed="clickContinueToProceed"
                        @clickCancelRedemption="clickCancelRedemption"
                        @clickClose="clickClose" />
                </div>
            </div>
        </b-modal>
        <copy-success-toast
            :controller="controller.copySuccessToast"
            v-if="controller.copySuccessToast != null">
        </copy-success-toast>
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//core
import RewardSevice from '@/core/Custom/service/RewardService.js';
//component
import Serial from './Serial.vue';
import SerialFooter from './SerialFooter.vue';
import SerialHeader from './SerialHeader.vue';
import SerialTimer from './SerialTimer.vue';
import FormatDate from '../Common/FormatDate.vue';
//custom component
import SerialRefillInfo from '../Custom/SerialRefillInfo.vue';
import CopySuccessToast from '@/components/Modal/Component/CopySuccessToast.vue';

export default {
    name: 'SerialModal',
    mixins: [LocaleMixin],
    components: {
        FormatDate,
        Serial,
        SerialHeader,
        SerialFooter,
        SerialTimer,
        SerialRefillInfo,
        CopySuccessToast
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        deeplinks: function () {
            return this.$store.state.deeplinks
        }
    },
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            campaign: null,
            campaignGroup: null,
            isAmbassadorCat: false,
            tag: null,
            serialType: '', //serial, refillinfo
            isShowFooterClose: false,
            isShowCancelRedemption: false,
            isMinMatch: false,
            redeemOnLbl: '',
            isShowTimer: false,

            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //event
        onSerialExpired: function(serial) {
            if (serial == 'XXXXXXX') {
                this.campaign.serial = serial;
            }
        },
        clickClose: function () {
            this.hide();
        },
         // clickClose: function () {
        //     this.hide();

        //     if (this.tag == 'detail') {
        //         this.controller.redeemSuccessModal
        //             .clearModal()
        //             .setCampaignGroup(this.campaignGroup)
        //             .setTag(this.tag)
        //             .show();

        //         this.controller.redeemSuccessModal
        //             .cbAction.onCallback(data => {
        //                 this.callbackAction(data.tag, data.action);
        //             });
        //     }
        // },
        clickBackToPrivilege: function () {
            this.hide();
            var deepLink = this.deeplinks.back_to_privilege || '';
            console.log('clickBackToPrivilege deepLink', deepLink);
            window.location.href = deepLink;
        },
        clickToMyCoupon: function () {
            this.hide();
            var deepLink = this.deeplinks.my_coupon || '';
            console.log('clickToMyCoupon deepLink', deepLink);

            window.location.href = deepLink;
        },
        clickContinueToProceed: function () {
            // new flow continue to proceed (1, 2, 3, 9)
            // old flow continue to proceed (4, 8)
            if (this.campaignGroup == '1' || this.campaignGroup == '2' || 
                this.campaignGroup == '3' || this.campaignGroup == '9' ||
                this.campaignGroup == '4' || this.campaignGroup == '8') {
                this.forwardUrlToAIA();
                return;
            }
            
            this.hide();
        },
        forwardUrlToAIA: function () {
            if (!this.campaign.privilegeMessage) {
                this.showForwardUrlError(
                    this.lbl.serial.error_msg || 'Failed to forward URL. Please try again.'
                );
                return;
            }
            
            try {
                var parsedJson = JSON.parse(this.campaign.privilegeMessage);
                if (parsedJson && parsedJson.AiaWeb) {
                    // Forward URL to AIA - this will trigger redirect
                    this.controller.cbAction.sendCallback({
                        tag: this.tag, 
                        action: 'redirect-aia', 
                        link: parsedJson.AiaWeb
                    });
                    this.hide();
                } else {
                    this.showForwardUrlError(
                        this.lbl.serial.error_msg || 'Invalid URL format. Please try again.'
                    );
                }
            } catch (e) {
                console.error('Error parsing privilegeMessage:', e);
                this.showForwardUrlError(
                    this.lbl.serial.error_msg || 'Failed to parse URL data. Please try again.'
                );
            }
        },
        showForwardUrlError: function (errorMsg) {
            // Show error modal with Retry and Cancel buttons using ConfirmModal
            this.controller.confirmModal
                .clearModal()
                .setTitle(this.lbl.default.error_title || 'Error')
                .setMsg(errorMsg || 'Failed to forward URL. Please try again.')
                .setBtnConfirm(this.lbl.default.retry || 'Retry')
                .setBtnCancel(this.lbl.default.cancel || 'Cancel')
                .show();
            
            // Handle Retry button - Forward URL again
            this.controller.confirmModal
                .cbConfirm.onCallback(() => {
                    this.forwardUrlToAIA();
                });
            
            // Handle Cancel button - Stay on the same Campaign Detail page
            this.controller.confirmModal
                .cbCancel.onCallback(() => {
                    // Cancel: Just close the error modal, stay on current page
                    // Don't navigate away - user stays on Campaign Detail page
                });
        },
        clickCancelRedemption: function () {
            this.hide();

            this.controller.confirmModal
                .clearModal()
                .setTitle(this.lbl.serial.cancel_title)
                .setMsg(this.lbl.serial.cancel_msg)
                .setBtnConfirm(this.lbl.serial.cancel_yes)
                .setBtnCancel(this.lbl.serial.cancel_no)
                .show();

            this.controller.confirmModal
                .cbConfirm.onCallback(() => {
                    this.apiCancelRedemption();
                });
        },
        clickRefillInformation: function () {
            if (this.campaign.privilegeMessage) {
                var parsedJson  = JSON.parse(this.campaign.privilegeMessage);
                this.controller.cbAction.sendCallback({tag: this.tag, action: 'redirect-aia', link: parsedJson.AiaWeb});
            }

            this.hide();
            // this.callbackAction(this.tag, 'refill-information');
            // this.$nextTick(()=> {
            //     this.hide();
            // });
        },
        //callback
        callbackAction: function (tag, action) {
            this.controller.cbAction.sendCallback({tag: tag, action: action});
        },
        //initial
        initialDetail: function () {
            this.serialType = 'serial';
            //for text
            if (this.campaign.expireIn) {
                this.isShowFooterClose = false;
                this.isShowTimer = true;
            } else {
                this.isShowFooterClose = true;
            }
            this.checkGroupForSerial();
            this.$bvModal.show(this.modalId);
        },
        checkGroupForSerial: function () {
            switch (this.campaignGroup) {
                case '5':
                case '6':
                case '7':
                case '1':
                case 'default':
                    this.redeemOnLbl = this.lbl.serial.group_five_redeem_on;
                break;
            }
        },
        initialHistory: function () {
            switch (this.campaignGroup) {
                case '1':
                case '2':
                case '3':
                case '9':
                    this.serialType = 'serial';
                    if (!this.campaign.isAvailable) {
                        this.isShowCancelRedemption = false;
                        this.isShowFooterClose = true;
                    } else {
                        this.isShowCancelRedemption = true;
                        this.isShowFooterClose = false;
                    }

                    this.redeemOnLbl = this.lbl.serial.group_one_redeem_on;
                    break;
                case '4':
                case '8':
                    this.serialType = 'refillinfo';
                    break;
                case '5':
                case '6':
                    this.serialType = 'serial';
                    if (this.campaign.expireIn) {
                        this.isShowFooterClose = false;
                    } else {
                        this.isShowFooterClose = true;
                    }

                    this.redeemOnLbl = this.lbl.serial.group_five_redeem_on;
                    break;
                case '7':
                case 'default':
                    this.serialType = 'serial';
                    if (this.campaign.expireIn) {
                        this.isShowFooterClose = false;
                    } else {
                        this.isShowFooterClose = true;
                    }

                    this.redeemOnLbl = this.lbl.serial.group_five_redeem_on;
                    break;
            }

            this.$bvModal.show(this.modalId);
        },
        //method
        apiCancelRedemption: function () {
            this.controller.loadingModal.show();

            var token = Account.getToken();
            RewardSevice.apiCancelRedemption(token, this.campaign.serial)
                .then(res => {
                    this.campaign.privilegeMessage = res.data.Inbound;
                    this.controller.loadingModal.hide();
                    this.controller.successModal
                        .setTitle(this.lbl.serial.cancel_success_title)
                        .setMsg(this.lbl.serial.cancel_success_msg)
                        .setBtnOk(this.lbl.serial.cancel_ok)
                        .show();

                    this.controller.successModal
                        .cbOk.onCallback(() => {
                            if (!this.campaign.privilegeMessage) return;

                            var parsedJson  = JSON.parse(this.campaign.privilegeMessage);
                            this.controller.cbAction.sendCallback({tag: this.tag, action: 'redirect-aia', link: parsedJson.AiaWeb});
                        });
                }).catch(err => {
                    this.controller.loadingModal.hide();
                    console.log('cancel resdemption err', err);
                    if (err.response && err.response.data && err.response.data.error.code == 403) {
                        this.controller.errorModal
                            .setMsg(this.lbl.serial.error_msg)
                            .setBtnConfirm(this.lbl.serial.cancel_ok)
                            .show();
                    }
                });
        },
        //modal control
        reset: function () {
            this.isShowFooterClose = false;
            this.isShowCancelRedemption = false
        },
        show: function (config) {
            this.campaign = config.campaign;
            this.campaignGroup = config.campaignGroup;
            this.isAmbassadorCat = config.isAmbassadorCat;
            this.tag = config.tag;
            
            this.reset();
            if (this.tag == 'detail')
                this.initialDetail();
            else {
                if (this.campaign.isMinPrivilegeMatch) {
                    this.isMinMatch = true;
                } 
                this.initialHistory();
            }
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
// #redeem_on_date {
//     font-size: 1.45rem;
//     // font-family: $heading;
//     // line-height: 1;
//     text-align: center;
// }

// .mass {
//     #redeem_on_date {
//         color: $mass_detail_font_color;
//     }
// }

// .prestige {
//     #redeem_on_date {
//         color: $prestige_detail_font_color;
//     }
// }
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";

.modal-serial {
    .modal-dialog {
        max-width: 400px;
    }

    .modal-content {
        border: 0px;
        border-radius: 8px;
        overflow: hidden;
    }

    .modal-body {
        padding: 24px;
    }

    .serial-modal__banner {
        padding: 12px 16px;
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        border-radius: 8px;

        .serial-modal__banner-content {
            display: flex;
            align-items: center;
            gap: 8px;

            .serial-modal__banner-icon {
                flex-shrink: 0;
            }

            .serial-modal__banner-text {
                font-size: 12px;
                font-weight: 600;
            }
        }

        &--success {
            background-color: $color-green-2;
            
            .serial-modal__banner-text {
                color: $color-green;
            }
        }

        &--error {
            background-color: rgba($color-red-2, 0.1);
            
            .serial-modal__banner-text {
                color: $color-red-2;
            }
        }
    }

    .serial-modal__content {
        .serial-modal__header {
            margin-bottom: 24px;
        }

        .serial-modal__footer {

            .serial-modal__footer-separator {
                // border-top: 1px solid #E5E7EB;
                // margin-bottom: 20px;
            }
        }
    }
}
</style>
